'use strict'

var assign = require('../constant/assign.js')

function shallow(object) {
  return assign({}, object)
}

module.exports = shallow



//////////////////
// WEBPACK FOOTER
// ./node_modules/micromark/dist/util/shallow.js
// module id = 217
// module chunks = 0